import { Controller } from "@hotwired/stimulus"

/*
This controller finds the first child element that matches a given CSS selector and 
smoothly scrolls it into view. The default selector is for the standard Rails "field_with_errors"
class.
For now, the assumption is that the element has just been re-rendered following an error 
response from the server, so the scrolling only happens on initial connect(). 
*/

export default class extends Controller {
  static values = {
    selector: { type: String, default: ".field_with_errors" },
    topPadding: { type: Number, default: 20 }
  }
    
  connect() {
    var selectedElements = Array.from(this.element.querySelectorAll(this.selectorValue)).filter(function(el) {
      return !el.classList.contains("hidden");
    });

    if (selectedElements.length > 0) {
      let position = selectedElements[0].getBoundingClientRect();
      window.scroll({left: position.left, top: position.top + window.scrollY - this.topPaddingValue, behavior: "smooth"}); 
    }    
  }
}
